import { render, staticRenderFns } from "./leftImages.vue?vue&type=template&id=bc983b9a&scoped=true&"
import script from "./leftImages.vue?vue&type=script&lang=js&"
export * from "./leftImages.vue?vue&type=script&lang=js&"
import style0 from "./leftImages.vue?vue&type=style&index=0&id=bc983b9a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc983b9a",
  null
  
)

export default component.exports